import React, {useMemo} from 'react'
import {FormattedMessage} from 'react-intl'
import {Box, Heading, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {localizeSameDomainHref} from '../../../utils/url'

const GAP_SIZE = 20 // Gap between items in pixels

const MoreToDiscover = ({discoverCategories, ...props}) => {
    const appOrigin = useAppOrigin()
    const {buildUrl} = useMultiSite()

    const categories = useMemo(() => {
        try {
            const parsed = JSON.parse(discoverCategories || '[]')
            if (!Array.isArray(parsed)) {
                return []
            }

            return parsed.map((category) => ({
                ...category,
                url: localizeSameDomainHref(category.url, {
                    buildUrl,
                    currentOrigin: appOrigin
                })
            }))
        } catch (error) {
            console.error('Failed to parse discoverCategories:', error)
            return []
        }
    }, [discoverCategories, buildUrl, appOrigin])

    return (
        <Box {...props}>
            <Heading as="h3" fontSize={{base: 'md', lg: 'xl'}} mb={{base: '12px', lg: '24px'}}>
                <FormattedMessage
                    id="product_detail.more_to_discover.heading"
                    defaultMessage="More to Discover"
                />
            </Heading>
            {/* CSS scroll container with bleed effect */}
            <Box
                display="flex"
                gap={`${GAP_SIZE}px`}
                overflowX="auto"
                mx={{base: '-16px', lg: '-24px'}}
                pl={{base: '16px', lg: '24px'}}
                pr={{base: '16px', lg: '24px'}}
                sx={{
                    // Hide scrollbar across browsers
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    WebkitOverflowScrolling: 'touch',
                    '& > *': {
                        flexShrink: 0
                    }
                }}
            >
                {categories.map(({id, name, url}) => (
                    <Link
                        key={id}
                        fontSize={{base: 'sm', lg: 'md'}}
                        fontWeight={500}
                        href={url}
                        whiteSpace="nowrap"
                    >
                        {name}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export default MoreToDiscover
